import * as tasks from './minigames/xml/SemPr20';

function transObjToArray(){
    let result = [];
    for(let task in tasks){
        result.push(tasks[task]);
    }
    return result;
}

export default transObjToArray();